export default {
  methods: {
    showConfirmModal: function (title, message) {
      this.$refs.confirm.showConfirmDialog = true;
      this.setConfirmModal(title, message);
    },
    setConfirmModal: function (title, message) {
      this.$refs.confirm.title = title;
      this.$refs.confirm.text = message;
    },
    hideConfirmModal: function () {
      this.$refs.confirm.showConfirmDialog = false;
    },
  },
};
